import React from 'react'
import { Radio } from '@mui/material'
import {
  FormLabel,
  FormError,
  RadioGroupWrap,
  CustomRadioIcon,
  CustomRadioCheckedIcon,
  FormControlLabelWrap,
} from './style'

const MuiRadioButton = (props) => {
  const { styletype, styling = '', ...rest } = props
  return (
    <>
      {styling === 'themeV2' ? (
        <>
          <FormControlLabelWrap
            control={
              <Radio
                checked={props.checked}
                value={props.value}
                name={props.name}
                icon={<CustomRadioIcon />}
                checkedIcon={<CustomRadioCheckedIcon />}
                sx={{
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                }}
                {...rest}
              />
            }
            label={props.title}
            className={styletype}
          />

          {props?.error && <FormError>{props.error}</FormError>}
        </>
      ) : (
        <RadioGroupWrap className={styletype} onChange={props.onChange}>
          <Radio
            checked={props.checked}
            value={props.value}
            name={props.name}
            variant='outlined'
            size='sm'
            className={styletype}
            {...rest}
          />
          {props?.title && <FormLabel>{props.title}</FormLabel>}
          {props?.error && <FormError>{props?.error}</FormError>}
        </RadioGroupWrap>
      )}
    </>
  )
}

export default MuiRadioButton
